import { IApplicationState } from '../../types/redux';

export function selectBanksList(state: IApplicationState) {
  return state.mortgageBanksData.banksList;
}

export function selectBanksRates(state: IApplicationState) {
  return state.mortgageBanksData.rates;
}
